<template>
  <van-popup
    v-model:show="rechargeTipsPopupConfig.isShow"
    position="center"
    class="recharge-tips-popup"
    teleport="body"
  >
    <div class="recharge-tips-content">
      <div class="msg" v-html="rechargeTipsPopupConfig.tipsText"></div>
      <van-button class="btn" @click="handleTo">
        <div class="flex center">
          {{ $t('recharge.TopUp') }}
        </div>
      </van-button>
    </div>
  </van-popup>
</template>

<!-- 充值提示弹窗 -->
<script setup lang="ts">
defineOptions({ name: 'RechargeTipsPopup' })

// 监听路由，切换页面关闭弹窗
const router = useRouter()
router.afterEach(() => {
  publicStore.setRechargeTipsPopup(false, '')
})

// 公共模块store
const publicStore = usePublicStore()
const { rechargeTipsPopupConfig } = storeToRefs(publicStore)
function handleTo() {
  publicStore.setRechargeTipsPopup(false, 1)
  if (rechargeTipsPopupConfig.value.toType === 'popup') {
    publicStore.setShowRechargePopup(true)
  } else {
    eventTracking.eventLogToPage({ path: '/recharge' })
  }
}
</script>

<style lang="scss">
.recharge-tips-popup {
  padding-top: 72px;
  width: 323px;
  background: transparent;
  text-align: center;
  .recharge-tips-content {
    padding-bottom: 20px;
    width: 323px;
    background: rgba(24, 24, 24, 0.8);
    border-radius: 18px;
  }
  .msg {
    min-height: 73px;
    padding: 18px 10px 10px;
    @include font-style(16px, #fff);
  }
  .btn {
    margin: 0 auto;
    flex: none;
    background: linear-gradient(90deg, #ffb400 0%, #e700b5 100%);
    border-radius: 26px;
    border: none;
    @include wh(258px, 50px);
    @include font-style(16px, #fff);
    font-weight: bold;
  }
}
</style>
